// ================================
// APP BACKGROUND
// Fixed, full-viewport astronaut/earth artwork + moving starfield, mounted
// once above all routes so it never unmounts/flickers on navigation. Pages
// stay on top of it by normal DOM stacking (see .global-bg in global.css) —
// they just need to not paint their own opaque background over it.
// ================================
import React from 'react';
import StarField from './StarField';

export default function AppBackground() {
  return (
    <div className="global-bg" aria-hidden="true">
      <StarField />
    </div>
  );
}
